function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "48",
  height: "48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23.998 8.4a15.55 15.55 0 0115.597 15.158L39.6 24l-.004.368C39.4 32.814 32.492 39.6 24 39.6c-8.616 0-15.6-6.984-15.6-15.6S15.384 8.4 23.998 8.4zM24 9.6C16.047 9.6 9.6 16.047 9.6 24S16.047 38.4 24 38.4 38.4 31.953 38.4 24l-.005-.426A14.35 14.35 0 0024 9.6zm0 19.198a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4zm0-3.511c1.15 0 2.25.468 3.046 1.296a.6.6 0 11-.864.832 3.027 3.027 0 00-4.363 0 .6.6 0 11-.865-.832A4.227 4.227 0 0124 25.287zm0-3.645c2.114 0 4.139.85 5.62 2.358a.6.6 0 11-.856.84 6.679 6.679 0 00-9.528 0 .6.6 0 11-.856-.84A7.879 7.879 0 0124 21.642zM24 18c3.08 0 6.031 1.233 8.196 3.423a.6.6 0 01-.854.844 10.323 10.323 0 00-14.684 0 .6.6 0 01-.854-.844A11.523 11.523 0 0124 18z",
  fill: "#0272B6"
}));